module.exports = __webpack_public_path__ + "static/img/no-city.e084fbae.png";